import { render, staticRenderFns } from "./statusIcon.vue?vue&type=template&id=47bb17a2&scoped=true"
import script from "./statusIcon.vue?vue&type=script&lang=js"
export * from "./statusIcon.vue?vue&type=script&lang=js"
import style0 from "./statusIcon.vue?vue&type=style&index=0&id=47bb17a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bb17a2",
  null
  
)

export default component.exports